import { AssetType } from 'common/disposition'
import { AssetTypeLabel, MainIconFlowState } from 'common/types'

export function getAssetTypeLabel(assetType: AssetType): AssetTypeLabel {
  if (assetType === null) {
    return null
  }

  switch (assetType?.toLowerCase()) {
    case 'non-biological':
      return 'Implantable Hardware/Associated Product'
    case 'biological':
      return 'Implantable Biologic'
    case 'other-non-biological':
      return 'Implantable Other'
    case 'consumable':
      return 'Consumable'
    case 'associated_asset':
      return 'Associated Product'
    default:
      return null
  }
}

export function getReadableAssetType(
  assetType: MainIconFlowState['assetTypeLabel']
): AssetTypeLabel {
  if (assetType === null) {
    return null
  }
  switch (assetType) {
    case 'IMPLANTABLE HARDWARE / ASSOCIATED PRODUCT':
    case 'ASSOCIATED PRODUCT':
      return 'Implantable Hardware/Associated Product'
    case 'IMPLANTABLE BIOLOGIC':
      return 'Implantable Biologic'
    case 'IMPLANTABLE OTHER':
      return 'Implantable Other'
    case 'CONSUMABLE PRODUCT':
      return 'Consumable'
    case 'EXPLANTED':
      return 'Explanted'
    default:
      return null
  }
}
